import { Component } from '@angular/core';

@Component({
  selector: 'app-aul-040-26',
  standalone: true,
  imports: [],
  templateUrl: './aul-040-26.component.html',
  styleUrl: './aul-040-26.component.scss'
})
export class Aul04026Component {

}
